// Destination-card localized titles/subs (used on the homepage Destinations grid).
export const DEST_I18N = {
 "en": {
  "/images/a_0902.webp": {
   "title": "Airport Transfer Zurich",
   "sub": "Fixed price from ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Airport Taxi Zurich",
   "sub": "24/7 with flight tracking"
  },
  "/images/a_1586.jpeg": {
   "title": "Airport Transfer Bern",
   "sub": "Bern · Geneva · Basel"
  },
  "/images/a_1587.webp": {
   "title": "Airport Transfer Basel",
   "sub": "Basel · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Airport Transfer Zurich",
   "sub": "Directly from the terminal"
  },
  "/images/a_1589.jpeg": {
   "title": "Business Travel with Chauffeur",
   "sub": "Discreet & punctual"
  },
  "/images/a_1590.webp": {
   "title": "Airport Transfer Interlaken",
   "sub": "Bernese Oberland"
  },
  "/images/a_1908.webp": {
   "title": "City to City",
   "sub": "Comfortable between cities"
  },
  "/images/a_2647.webp": {
   "title": "Airport Transfer St. Moritz",
   "sub": "Engadine · Alpine Transfer"
  },
  "/images/a_2648.webp": {
   "title": "Trade Fair Transfers",
   "sub": "Basel · Zurich · Geneva"
  },
  "/images/a_2650.webp": {
   "title": "Airport Transfer to the Alps",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Group Transfer",
   "sub": "Vans & Sprinters for up to 16 people"
  }
 },
 "fr": {
  "/images/a_0902.webp": {
   "title": "Transfert aéroport Zürich",
   "sub": "Prix fixe depuis ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Taxi aéroport Zürich",
   "sub": "24/7 avec suivi de vol"
  },
  "/images/a_1586.jpeg": {
   "title": "Transfert aéroport Bern",
   "sub": "Bern · Genève · Bâle"
  },
  "/images/a_1587.webp": {
   "title": "Transfert aéroport Bâle",
   "sub": "Bâle · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Transfert aéroport Zürich",
   "sub": "Directement depuis le terminal"
  },
  "/images/a_1589.jpeg": {
   "title": "Voyages d'affaires avec chauffeur",
   "sub": "Discret & ponctuel"
  },
  "/images/a_1590.webp": {
   "title": "Transfert aéroport Interlaken",
   "sub": "Jura bernois"
  },
  "/images/a_1908.webp": {
   "title": "Ville à ville",
   "sub": "Confortable entre les villes"
  },
  "/images/a_2647.webp": {
   "title": "Transfert aéroport St. Moritz",
   "sub": "Engadine · Transfert alpin"
  },
  "/images/a_2648.webp": {
   "title": "Transferts pour les foires",
   "sub": "Bâle · Zürich · Genève"
  },
  "/images/a_2650.webp": {
   "title": "Transfert aéroport vers les Alpes",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Transfert de groupe",
   "sub": "Vans & Sprinter jusqu'à 16 pers."
  }
 },
 "it": {
  "/images/a_0902.webp": {
   "title": "Trasferimento aeroportuale a Zürich",
   "sub": "Tariffa fissa da ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Taxi aeroportuale a Zürich",
   "sub": "24/7 con monitoraggio voli"
  },
  "/images/a_1586.jpeg": {
   "title": "Trasferimento aeroportuale a Berna",
   "sub": "Berna · Genf · Basilea"
  },
  "/images/a_1587.webp": {
   "title": "Trasferimento aeroportuale a Basilea",
   "sub": "Basilea · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Trasferimento aeroportuale a Zürich",
   "sub": "Direttamente dal terminal"
  },
  "/images/a_1589.jpeg": {
   "title": "Viaggi d'affari con autista",
   "sub": "Discreto & puntuale"
  },
  "/images/a_1590.webp": {
   "title": "Trasferimento aeroportuale a Interlaken",
   "sub": "Berner Oberland"
  },
  "/images/a_1908.webp": {
   "title": "Città a città",
   "sub": "Confortevole tra le città"
  },
  "/images/a_2647.webp": {
   "title": "Trasferimento aeroportuale a St. Moritz",
   "sub": "Engadina · Trasferimento alpino"
  },
  "/images/a_2648.webp": {
   "title": "Trasferimenti per fiere",
   "sub": "Basilea · Zürich · Genf"
  },
  "/images/a_2650.webp": {
   "title": "Trasferimento aeroportuale per le Alpi",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Trasferimento per gruppi",
   "sub": "Vans & Sprinter fino a 16 persone"
  }
 },
 "es": {
  "/images/a_0902.webp": {
   "title": "Transfer al aeropuerto de Zürich",
   "sub": "Precio fijo desde ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Taxi al aeropuerto de Zürich",
   "sub": "24/7 con seguimiento de vuelo"
  },
  "/images/a_1586.jpeg": {
   "title": "Transfer al aeropuerto de Berna",
   "sub": "Berna · Ginebra · Basilea"
  },
  "/images/a_1587.webp": {
   "title": "Transfer al aeropuerto de Basilea",
   "sub": "Basilea · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Transfer al aeropuerto de Zürich",
   "sub": "Directo desde la terminal"
  },
  "/images/a_1589.jpeg": {
   "title": "Viajes de negocios con chófer",
   "sub": "Discreto y puntual"
  },
  "/images/a_1590.webp": {
   "title": "Transfer al aeropuerto de Interlaken",
   "sub": "Berna Oberland"
  },
  "/images/a_1908.webp": {
   "title": "De ciudad a ciudad",
   "sub": "Cómodo entre ciudades"
  },
  "/images/a_2647.webp": {
   "title": "Transfer al aeropuerto de St. Moritz",
   "sub": "Engadina · Transfer hacia los Alpes"
  },
  "/images/a_2648.webp": {
   "title": "Transfers de ferias",
   "sub": "Basilea · Zürich · Ginebra"
  },
  "/images/a_2650.webp": {
   "title": "Transfer al aeropuerto hacia los Alpes",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Transfer para grupos",
   "sub": "Vans y Sprinter hasta 16 Pers."
  }
 },
 "pt": {
  "/images/a_0902.webp": {
   "title": "Transfer de aeroporto em Zürich",
   "sub": "Preço fixo a partir de ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Taxi de aeroporto em Zürich",
   "sub": "24/7 com rastreamento de voo"
  },
  "/images/a_1586.jpeg": {
   "title": "Transfer de aeroporto em Bern",
   "sub": "Bern · Genf · Basel"
  },
  "/images/a_1587.webp": {
   "title": "Transfer de aeroporto em Basel",
   "sub": "Basel · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Transfer de aeroporto em Zürich",
   "sub": "Direto do terminal"
  },
  "/images/a_1589.jpeg": {
   "title": "Viagens de negócios com chauffeur",
   "sub": "Discreto & pontual"
  },
  "/images/a_1590.webp": {
   "title": "Transfer de aeroporto em Interlaken",
   "sub": "Berner Oberland"
  },
  "/images/a_1908.webp": {
   "title": "Cidade a cidade",
   "sub": "Confortável entre cidades"
  },
  "/images/a_2647.webp": {
   "title": "Transfer de aeroporto em St. Moritz",
   "sub": "Engadin · Transfer Alpino"
  },
  "/images/a_2648.webp": {
   "title": "Transfers para feiras",
   "sub": "Basel · Zürich · Genf"
  },
  "/images/a_2650.webp": {
   "title": "Transfer de aeroporto para Alpins",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Transfer em grupo",
   "sub": "Vans & Sprinter até 16 pessoas"
  }
 },
 "tr": {
  "/images/a_0902.webp": {
   "title": "Zürih Havalimanı Transferi",
   "sub": "ZRH'den sabit fiyat"
  },
  "/images/a_1583.jpeg": {
   "title": "Zürih Havalimanı Taksisi",
   "sub": "24/7 uçuş takibiyle"
  },
  "/images/a_1586.jpeg": {
   "title": "Bern Havalimanı Transferi",
   "sub": "Bern · Cenevre · Basel"
  },
  "/images/a_1587.webp": {
   "title": "Basel Havalimanı Transferi",
   "sub": "Basel · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Zürih Havalimanı Transferi",
   "sub": "Terminalden doğrudan"
  },
  "/images/a_1589.jpeg": {
   "title": "Şoförlü İş Seyahatleri",
   "sub": "Gizli & zamanında"
  },
  "/images/a_1590.webp": {
   "title": "Interlaken Havalimanı Transferi",
   "sub": "Berner Oberland"
  },
  "/images/a_1908.webp": {
   "title": "Şehirden Şehire",
   "sub": "Şehirler arasında konforlu"
  },
  "/images/a_2647.webp": {
   "title": "St. Moritz Havalimanı Transferi",
   "sub": "Engadin · Alpentransfer"
  },
  "/images/a_2648.webp": {
   "title": "Fuarda Transferler",
   "sub": "Basel · Zürih · Cenevre"
  },
  "/images/a_2650.webp": {
   "title": "Alplere Havalimanı Transferi",
   "sub": "Zermatt · Verbier · Davos"
  },
  "/images/a_2651.webp": {
   "title": "Gruppentransfer",
   "sub": "16 kişiye kadar Vans & Sprinter"
  }
 },
 "ru": {
  "/images/a_0902.webp": {
   "title": "Трансфер из аэропорта Цюрих",
   "sub": "Фиксированная цена от ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "Такси в аэропорт Цюрих",
   "sub": "24/7 с отслеживанием рейсов"
  },
  "/images/a_1586.jpeg": {
   "title": "Трансфер из аэропорта Берн",
   "sub": "Берн · Женева · Базель"
  },
  "/images/a_1587.webp": {
   "title": "Трансфер из аэропорта Базель",
   "sub": "Базель · EuroAirport · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "Трансфер из аэропорта Цюрих",
   "sub": "Прямо из терминала"
  },
  "/images/a_1589.jpeg": {
   "title": "Деловые поездки с водителем",
   "sub": "Дискретно и вовремя"
  },
  "/images/a_1590.webp": {
   "title": "Трансфер из аэропорта Интерлакен",
   "sub": "Бернское Оберланд"
  },
  "/images/a_1908.webp": {
   "title": "Город к городу",
   "sub": "Комфортное перемещение между городами"
  },
  "/images/a_2647.webp": {
   "title": "Трансфер из аэропорта Санкт-Мориц",
   "sub": "Энгадин · Альпийский трансфер"
  },
  "/images/a_2648.webp": {
   "title": "Трансферы на выставки",
   "sub": "Базель · Цюрих · Женева"
  },
  "/images/a_2650.webp": {
   "title": "Трансфер в Альпы",
   "sub": "Церматт · Вербье · Давос"
  },
  "/images/a_2651.webp": {
   "title": "Групповой трансфер",
   "sub": "Вэны и спринтеры до 16 человек"
  }
 },
 "ar": {
  "/images/a_0902.webp": {
   "title": "نقل المطار في زيورخ",
   "sub": "سعر ثابت من ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "تاكسي المطار في زيورخ",
   "sub": "24/7 مع تتبع الرحلات الجوية"
  },
  "/images/a_1586.jpeg": {
   "title": "نقل المطار في برن",
   "sub": "برن · جنيف · بازل"
  },
  "/images/a_1587.webp": {
   "title": "نقل المطار في بازل",
   "sub": "بازل · يوروإيربورت · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "نقل المطار في زيورخ",
   "sub": "مباشرة منterminal"
  },
  "/images/a_1589.jpeg": {
   "title": "رحلات عمل مع سائق",
   "sub": "بشكل سري وموعد دقيق"
  },
  "/images/a_1590.webp": {
   "title": "نقل المطار في إنترلاكن",
   "sub": "برنر أوبيرلاند"
  },
  "/images/a_1908.webp": {
   "title": "من مدينة إلى أخرى",
   "sub": "راحة بين المدن"
  },
  "/images/a_2647.webp": {
   "title": "نقل المطار في سانت موريتز",
   "sub": "إنغادين · نقل جبلي"
  },
  "/images/a_2648.webp": {
   "title": "نقل المعارض",
   "sub": "بازل · زيورخ · جنيف"
  },
  "/images/a_2650.webp": {
   "title": "نقل المطار إلى جبال الألب",
   "sub": "زيارتي · فيربير · دافوس"
  },
  "/images/a_2651.webp": {
   "title": "نقل المجموعات",
   "sub": "فانات وسبرينتر حتى 16 شخصاً"
  }
 },
 "fa": {
  "/images/a_0902.webp": {
   "title": "انتقال فرودگاهی زوریخ",
   "sub": "قیمت ثابت از ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "تاکسی فرودگاهی زوریخ",
   "sub": "24/7 با پیگیری پرواز"
  },
  "/images/a_1586.jpeg": {
   "title": "انتقال فرودگاهی برن",
   "sub": "برن · ژنو · بازل"
  },
  "/images/a_1587.webp": {
   "title": "انتقال فرودگاهی بازل",
   "sub": "بازل · یورو فرودگاه · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "انتقال فرودگاهی زوریخ",
   "sub": "مستقیم از ترمینال"
  },
  "/images/a_1589.jpeg": {
   "title": "سفرهای تجاری با راننده",
   "sub": "با احتیاط و به موقع"
  },
  "/images/a_1590.webp": {
   "title": "انتقال فرودگاهی اینترلاکن",
   "sub": "برنر اوبرلند"
  },
  "/images/a_1908.webp": {
   "title": "شهر به شهر",
   "sub": "راحت و آسوده بین شهرها"
  },
  "/images/a_2647.webp": {
   "title": "انتقال فرودگاهی سنت موریس",
   "sub": "انگادین · انتقال کوهستانی"
  },
  "/images/a_2648.webp": {
   "title": "انتقالات نمایشگاهی",
   "sub": "بازل · زوریخ · ژنو"
  },
  "/images/a_2650.webp": {
   "title": "انتقال فرودگاهی به آلپ‌ها",
   "sub": "زرمات · وربیر · داووس"
  },
  "/images/a_2651.webp": {
   "title": "انتقال گروهی",
   "sub": "ون و اسپرینتر تا 16 نفر"
  }
 },
 "hi": {
  "/images/a_0902.webp": {
   "title": "एयरपोर्ट ट्रांसफर ज़ürich",
   "sub": "फिक्स्ड प्राइस ज़RH से"
  },
  "/images/a_1583.jpeg": {
   "title": "एयरपोर्ट टैक्सी ज़ürich",
   "sub": "24/7 फ्लाइट ट्रैकिंग के साथ"
  },
  "/images/a_1586.jpeg": {
   "title": "एयरपोर्ट ट्रांसफर बर्न",
   "sub": "बर्न · जेनेवा · बेसल"
  },
  "/images/a_1587.webp": {
   "title": "एयरपोर्ट ट्रांसफर बेसल",
   "sub": "बासेल · यूरोएयरपोर्ट · ज़RH"
  },
  "/images/a_1588.jpeg": {
   "title": "एयरपोर्ट ट्रांसफर ज़ürich",
   "sub": "टर्मिनल से सीधे"
  },
  "/images/a_1589.jpeg": {
   "title": "व्यावसायिक यात्रा के साथ चॉफ़र",
   "sub": "गोपनीय और समय पर"
  },
  "/images/a_1590.webp": {
   "title": "एयरपोर्ट ट्रांसफर इंटरलाकेन",
   "sub": "बर्नर ओबरलैंड"
  },
  "/images/a_1908.webp": {
   "title": "शहर से शहर",
   "sub": "शहरों के बीच आरामदायक"
  },
  "/images/a_2647.webp": {
   "title": "एयरपोर्ट ट्रांसफर सेंट मोरिट्ज",
   "sub": "एंगडिन · आल्प ट्रांसफर"
  },
  "/images/a_2648.webp": {
   "title": "मेला ट्रांसफर्स",
   "sub": "बासेल · ज़ürich · जेनेवा"
  },
  "/images/a_2650.webp": {
   "title": "एयरपोर्ट ट्रांसफर पहाड़ों के लिए",
   "sub": "ज़र्माट · वर्बियर · डावोस"
  },
  "/images/a_2651.webp": {
   "title": "ग्रुप ट्रांसफर",
   "sub": "वैन और स्प्रिंटर 16 व्यक्तियों तक"
  }
 },
 "zh": {
  "/images/a_0902.webp": {
   "title": "苏州兰机场接送服务 - 苏黎世",
   "sub": "从ZRH起的固定价格"
  },
  "/images/a_1583.jpeg": {
   "title": "苏州兰机场出租车 - 苏黎世",
   "sub": "24/7提供航班追踪"
  },
  "/images/a_1586.jpeg": {
   "title": "苏州兰机场接送服务 - 伯尔尼",
   "sub": "伯尔尼 · 日内瓦 · 巴塞尔"
  },
  "/images/a_1587.webp": {
   "title": "苏州兰机场接送服务 - 巴塞尔",
   "sub": "巴塞尔 · 欧洲机场 · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "苏州兰机场接送服务 - 苏黎世",
   "sub": "直接从航站楼出发"
  },
  "/images/a_1589.jpeg": {
   "title": "商务旅行与司机",
   "sub": "私密 & 准时"
  },
  "/images/a_1590.webp": {
   "title": "苏州兰机场接送服务 - 因特拉肯",
   "sub": "伯尔尼高地"
  },
  "/images/a_1908.webp": {
   "title": "城市间接送",
   "sub": "在城市之间舒适地移动"
  },
  "/images/a_2647.webp": {
   "title": "苏州兰机场接送服务 - 圣莫里茨",
   "sub": "恩噶丁 · 阿尔卑斯接送"
  },
  "/images/a_2648.webp": {
   "title": "展会接送",
   "sub": "巴塞尔 · 苏黎世 · 日内瓦"
  },
  "/images/a_2650.webp": {
   "title": "前往阿尔卑斯的机场接送",
   "sub": "采尔马特 · 韦伯耶 · 达沃斯"
  },
  "/images/a_2651.webp": {
   "title": "团体接送",
   "sub": "面包车 & 花车最多可容纳16人"
  }
 },
 "ko": {
  "/images/a_0902.webp": {
   "title": "취리히 공항 전송",
   "sub": "ZRH에서 고정 요금"
  },
  "/images/a_1583.jpeg": {
   "title": "취리히 공항 택시",
   "sub": "24/7 비행 추적"
  },
  "/images/a_1586.jpeg": {
   "title": "베른 공항 전송",
   "sub": "베른 · 제네바 · 바젤"
  },
  "/images/a_1587.webp": {
   "title": "바젤 공항 전송",
   "sub": "바젤 · 유로에어포트 · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "취리히 공항 전송",
   "sub": "터미널에서 바로"
  },
  "/images/a_1589.jpeg": {
   "title": "운전사와의 비즈니스 여행",
   "sub": "모든 게 discret & 시간 엄수"
  },
  "/images/a_1590.webp": {
   "title": "인터라켄 공항 전송",
   "sub": "베른 오버란트"
  },
  "/images/a_1908.webp": {
   "title": "도시 대 도시",
   "sub": "도시 간 편안하게"
  },
  "/images/a_2647.webp": {
   "title": "생 모리츠 공항 전송",
   "sub": "엥가딘 · 알프스 전송"
  },
  "/images/a_2648.webp": {
   "title": "전시회 전송",
   "sub": "바젤 · 취리히 · 제네바"
  },
  "/images/a_2650.webp": {
   "title": "알프스행 공항 전송",
   "sub": "체르마트 · 베르비에 · 다보스"
  },
  "/images/a_2651.webp": {
   "title": "단체 전송",
   "sub": "16명까지 가능한 밴 & 스프린터"
  }
 },
 "ckb": {
  "/images/a_0902.webp": {
   "title": "گواستنەوەی فڕۆکەخانەی زوریخ",
   "sub": "نرخی جێگیر لە ZRH"
  },
  "/images/a_1583.jpeg": {
   "title": "تاکسی فڕۆکەخانەی زوریخ",
   "sub": "٢٤/٧ لەگەڵ شوێنکەوتنی فڕۆکە"
  },
  "/images/a_1586.jpeg": {
   "title": "گواستنەوەی فڕۆکەخانەی بێرن",
   "sub": "بێرن · جنێڤ · بازێل"
  },
  "/images/a_1587.webp": {
   "title": "گواستنەوەی فڕۆکەخانەی بازێل",
   "sub": "بازێل · یورۆئێرپۆرت · ZRH"
  },
  "/images/a_1588.jpeg": {
   "title": "گواستنەوەی فڕۆکەخانەی زوریخ",
   "sub": "ڕاستەوخۆ لە تێرمیناڵەوە"
  },
  "/images/a_1589.jpeg": {
   "title": "گەشتی بازرگانی بە شۆفێر",
   "sub": "نهێنیانە و لە کاتی خۆیدا"
  },
  "/images/a_1590.webp": {
   "title": "گواستنەوەی فڕۆکەخانەی ئینتەرلاکن",
   "sub": "بەرنیز ئۆبەرلاند"
  },
  "/images/a_1908.webp": {
   "title": "شار بۆ شار",
   "sub": "ئاسوودە لە نێوان شارەکان"
  },
  "/images/a_2647.webp": {
   "title": "گواستنەوەی فڕۆکەخانەی سانت مۆریتز",
   "sub": "ئێنگادین · گواستنەوەی ئاڵپی"
  },
  "/images/a_2648.webp": {
   "title": "گواستنەوە بۆ پێشانگاکان",
   "sub": "بازێل · زوریخ · جنێڤ"
  },
  "/images/a_2650.webp": {
   "title": "گواستنەوەی فڕۆکەخانە بۆ ئاڵپەکان",
   "sub": "زێرمات · ڤێربیێ · داڤۆس"
  },
  "/images/a_2651.webp": {
   "title": "گواستنەوەی گروپی",
   "sub": "ڤان و سپرینتەر بۆ تا ١٦ کەس"
  }
 }
};
